<template>
    <div class="modal" v-show="modalShown" v-drag="{handle:'#modal-moving'}">
        <div class="modal-main">
        <div class="title-area" id="modal-moving">
            <h2>ステータス変更</h2>
        </div>
        <div class="data-area">
            <select v-model="status">
                <option value="" disabled selected>ステータス変更</option>
                <option :value="0">未提案</option>
                <option :value="1">担当割り当て済み</option>
                <option :value="2">提案中</option>
                <option :value="3">差し戻し</option>
                <option :value="4">確定</option>
            </select>
        </div>
        <div class="modal-footer">
            <button class="main_btn" @click="applyStatus(status, index)">適用</button>
            <button class="main_btn" @click="close()">×</button>
        </div>
    </div>
    </div>
</template>
<script>
import * as AppUtil from '../../../utils/App'

export default {
  name: 'SketchPersonModal',
  data () {
    return {
      modalShown: false,
      status: '',
      index: ''
    }
  },
  watch: {
  },
  methods: {
    showModal: function (currentStatus, index) {
      this.modalShown = true
      this.status = currentStatus
      this.index = index
    },
    close: function () {
      this.modalShown = false
    },
    /** ステータス変更を親コンポーネントに通知 */
    changeStatus: function (status, index) {
      this.$emit('statusChanged', {status: status, index: index})
    },
    /** ステータス適用 */
    applyStatus: function (status, index) {
      this.modalShown = false
      let modalData = {
        messages: ['ステータスを変更しました。']
      }
      this.changeStatus(status, index)
      AppUtil.showModal(modalData)
    }
  }
}
</script>
<style lang="scss" scoped>
.modal{
  position: fixed
}

li{
  margin-bottom: 20px;
  div{
    width: 175px;
    display: inline-block;
    padding: 10px;
    text-align: left;
  }
  .label{
    min-width: 190px;
    display: inline-block;
    text-align: left;
    font-weight: bold;
  }
  .error_message{
    padding: 0px;
    width: auto;
  }
}
.data-area {
  padding: 20px;
}
.modal-main{
  max-height: 100%;
}
.row {
  display: flex;
  justify-content: start;
  margin-left: 65px;
  margin-bottom: 30px;
}
.content {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/list/modal/SketchProposedStatus.vue